import React from 'react';
import './PayStackHook.css';
import { usePaystackPayment } from 'react-paystack';

const PayStackHook = ({config, handleEnroll}) => {
  const initializePayment = usePaystackPayment(config);

  const onSuccess = (reference) => {
    // Handle successful transaction here (e.g., update DB, redirect user)
    handleEnroll();
  };

  const onClose = () => {
    // Handle checkout modal closure
    console.log('Payment window closed');
  };

  return (
    <div>
      <button 
        type='button'
        onClick={() => initializePayment({ onSuccess, onClose })}
        className="payment-btn"
      >
        Pay to Enroll
      </button>
    </div>
  );
};

export default PayStackHook;
